import { network } from 'services/network';

import { QueryParams } from 'api/mutations/login.mutation';

export const login = (params: QueryParams) => {
    return network.post('admin/bo/login', params).then((response) => {
        return response.data;
    });
};
